import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { FormTable, FormTableRow } from '../issues/FormTable'
import { RegisteredNumericField } from '../../../components/fields/NumericField'
import { RegisteredCheckBox } from '../../../components/fields/CheckBox'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import { FeeForm, FeeFormWithId } from '../types/FeeForm'

interface FeeDialogProps {
    fee: Partial<FeeFormWithId>
    open: boolean
    setOpen: (val: boolean) => void
    handleSubmitFee: (fee: FeeForm) => void
}

export function FeeDialog({ fee, handleSubmitFee, open, setOpen }: FeeDialogProps) {
    const formMethods = useForm<FeeForm>({ defaultValues: fee })
    const topDownValue = formMethods.watch('topDown')
    const middleDownValue = formMethods.watch('middleDown')
    const handleClose = () => {
        setOpen(false)
    }
    const handleSubmit = () => {
        const data = formMethods.getValues()
        const newFee = { ...fee, ...data }
        handleSubmitFee(newFee)
        setOpen(false)
    }

    return (
        <FormProvider {...formMethods}>
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>Arvode</DialogTitle>
                <DialogContent>
                    <FormTable>
                        <FormTableRow label='Nivå'>
                            <RegisteredNumericField label='Nivå' name='feeLevel' />
                        </FormTableRow>
                        <FormTableRow label='Arvode'>
                            <RegisteredNumericField label='Arvode' name='feeCash' percentage={true} />
                        </FormTableRow>
                        <FormTableRow label='Arvode units'>
                            <RegisteredNumericField label='Arvode units' name='feeUnits' percentage={true} />
                        </FormTableRow>
                        <FormTableRow label='Arvode båda'>
                            <RegisteredCheckBox label='' name='feeBoth' />
                        </FormTableRow>
                        <FormTableRow label='Top-down'>
                            <RegisteredCheckBox label='' name='topDown' disabled={!!middleDownValue} />
                        </FormTableRow>
                        <FormTableRow label='Middle-down'>
                            <RegisteredNumericField
                                label='Startar vid (%)'
                                name='middleDown'
                                percentage={true}
                                disabled={!!topDownValue}
                            />
                        </FormTableRow>
                    </FormTable>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Avbryt</Button>
                    <Button onClick={handleSubmit}>Ok</Button>
                </DialogActions>
            </Dialog>
        </FormProvider>
    )
}
